import { FC } from 'react';
import { StyleSheet } from '@react-pdf/renderer';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { numberToCurrencyString } from '../../../../utils';
import Typography from '../../../Pdf/components/Typography';
import Divider from '../../../Pdf/components/Divider';
import Column from '../../../Pdf/components/Column';
import Row from '../../../Pdf/components/Row';
import theme from '../../../Pdf/components/theme';

const styles = StyleSheet.create({
  statsRow: {
    marginTop: '6px',
    marginBottom: '6px',
  },
  fundDateColumn: {
    paddingLeft: '10px',
  },
  fundDateLabel: {
    fontSize: '7px',
    lineHeight: '7px',
  },
  statColumn: {
    gap: '6px',
    margin: theme.spacing(
      theme.spacingSizes.xxs,
      theme.spacingSizes.xl,
      theme.spacingSizes.xxs,
      theme.spacingSizes.sm,
    ),
  },
  divider: {
    margin: theme.spacing(theme.spacingSizes.xxs, 0),
  },
  statLabel: {
    fontSize: '7px',
    lineHeight: '7px',
    color: theme.palette.grey[500],
  },
  statValue: {
    fontSize: '8px',
    lineHeight: '8px',
  },
});

type Props = {
  title: string;
  subtitle: string;
  acquisitionValue: number;
  currentValue: number;
  baseCurrency: CurrencyCode;
};

const PortfolioTotal: FC<Props> = ({
  title,
  subtitle,
  acquisitionValue,
  currentValue,
  baseCurrency,
}) => {
  return (
    <Row justify="space-between" style={styles.statsRow}>
      <Column spacing="xs" style={styles.fundDateColumn}>
        <Typography bold style={styles.fundDateLabel}>
          {title}
        </Typography>
        <Typography
          color={theme.palette.grey[500]}
          bold
          style={styles.fundDateLabel}
        >
          {subtitle}
        </Typography>
      </Column>
      <Row>
        <Column style={styles.statColumn}>
          <Typography bold style={styles.statLabel}>
            Total portfolio acquisition value
          </Typography>
          <Typography bold style={styles.statValue}>
            {numberToCurrencyString(acquisitionValue, {
              currency: baseCurrency,
              negativeInBrackets: true,
            })}
          </Typography>
        </Column>
        <Divider orientation="vertical" style={styles.divider} />
        <Column spacing="xs" style={styles.statColumn}>
          <Typography bold style={styles.statLabel}>
            Total portfolio current value
          </Typography>
          <Typography bold style={styles.statValue}>
            {numberToCurrencyString(currentValue, {
              currency: baseCurrency,
              negativeInBrackets: true,
            })}
          </Typography>
        </Column>
      </Row>
    </Row>
  );
};

export default PortfolioTotal;
